export const getHref = (link?: string | null) => {
  if (!link) {
    return ''
  }
  return link?.startsWith('http') ? link : '//' + link
}
